<template>
  <div id="data-dashboard">
    <a href="#" class="sr-only" @click.prevent="scrollToContent()">Skip to main content</a>
    <NavBar />
    <div ref="mainContent" tabindex="-1">
      <div class="home-page" v-if="isAbout">
        <SiteIntro />
        <AboutPage />
      </div>
      <div v-if="isDashboard" class="dashboard-page">
        <DataDashboard />
      </div>
      <div v-if="isActionPlan" class="action-plan-page">
        <ActionPlanPage />
      </div>
      <div v-if="isResource" class="resources-page">
        <ResourcesPage />
      </div>
      <div v-if="isInsights" class="insights-page">
        <InsightsPage />
      </div>
    </div>
    <p class="email-line">For questions about FleetREDI, contact the team at <a href="mailto:FleetREDI@nlr.gov">FleetREDI@nlr.gov</a></p>
    <FooterBar />

  </div>
</template>

<script setup>
import '@/assets/styles/app.scss';
import NavBar from '@/components/NavBar.vue';
import SiteIntro from '@/components/SiteIntro.vue';
import AboutPage from '@/components/AboutPage.vue';
import DataDashboard from '@/components/DataDashboard.vue';
import ResourcesPage from '@/components/ResourcesPage.vue';
import ActionPlanPage from '@/components/ActionPlanPage.vue';
import InsightsPage from '@/components/InsightsPage.vue';
import FooterBar from '@/components/FooterBar.vue';

import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const mainContent = ref(null);
const store = useStore();
const isDashboard = computed(() => store.getters.isDashboard);
const isAbout = computed(() => store.getters.isAbout);
const isResource = computed(() => store.getters.isResource);
const isActionPlan = computed(() => store.getters.isActionPlan);
const isInsights = computed(() => store.getters.isInsights);

function scrollToContent() {
  mainContent.value.scrollIntoView();
  mainContent.value.focus();
}

</script>
